module.exports = __webpack_public_path__ + "media/images/recruit/environments/ph_07-54ae867f4e66e9bf33a0c1084b2fe6ee.jpg";